import React from "react";
import NewsroomMediaOne from "../component/NewsroomMediaOne";

function NewsroomMediaOneContainer() {
  return <NewsroomMediaOne />;
}

export default NewsroomMediaOneContainer;
